import React from 'react';
import './MoralAlignmentTooltip.css';

interface MoralAlignmentTooltipProps {
  explanation: string | null;
}

const MoralAlignmentTooltip: React.FC<MoralAlignmentTooltipProps> = ({ explanation }) => {
  return (
    <div className="moral-alignment-tooltip">
      {explanation ? (
        <p>{explanation}</p>
      ) : (
        <p>No explanation available.</p>
      )}
    </div>
  );
};

export default MoralAlignmentTooltip;